import Chartist from "chartist";
import ChartistTooltip from 'chartist-plugin-tooltips-updated';

// Hooks
//
const entryHook = "[js-graph-entry]";
const selectHook = "[js-graph-select]";

// Classes
//

class GraphComponent {
  constructor(element) {
    this.element = element;
    this.entry = element.querySelector(entryHook);
    this.selects = element.querySelectorAll(selectHook);
    this.canvas = null;
    this.data = [];
    this.labels = [];
    this.settings = {
      type: element.dataset.type || "gold",
      valuta: element.dataset.valuta || "EUR",
      unit: element.dataset.unit || "grammes",
      time: element.dataset.time || "hour",
    };

    this.init();
    this.fetchData();
    this.loop();
  }

  init() {
    this.selects?.forEach(ele => {
      ele.addEventListener('change', (e) => { 
        this.settings[e.target.name] = e.target.value
        this.fetchData()
      })
    })
  }

  async fetchData() {
    const { type, valuta, unit, time } = this.settings;
    const url = `https://rates.wpid.nl/api/${type}/graph/${time}?currency=${valuta}&weight_unit=${unit == 'kilo' ? 'grammes' : unit}`;
    let labels = [];
    let data = [];
    const res = await fetch(url);
    const json = await res.json();
    const sorted = json.sort((a, b) => {
      return a.time.localeCompare(b.time);
    });

    const month = new Array();
    month[0] = "Jan";
    month[1] = "Feb";
    month[2] = "Mrt";
    month[3] = "Apr";
    month[4] = "Mei";
    month[5] = "Jun";
    month[6] = "Jul";
    month[7] = "Aug";
    month[8] = "Sep";
    month[9] = "Okt";
    month[10] = "Nov";
    month[11] = "Dec";

    const parseMinutes = (date) => {
      return date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    }

    const parseHours = (date) => {
      return date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
    }

    const countDecimals = (value) => {
      if(Math.floor(value) === value) return 0;
      return value.toString().split(".")[1].length || 0; 
  }

    sorted.forEach((item) => {
      let date = new Date(item.time);
      let time = '';
      
      if (this.settings.time === 'decade') time = `${date.getFullYear()}`;
      if (this.settings.time === 'year') time = `${month[date.getMonth()]}. ${date.getFullYear()}`;
      if (this.settings.time === 'week' || this.settings.time === 'month') time = `${date.getDate()} ${month[date.getMonth()]}`;
      if (this.settings.time === 'day' || this.settings.time === 'hour') time = `${parseHours(date)}:${parseMinutes(date)}`;

      const value = this.settings.unit == 'kilo' ? item.bid * 1000 : item.bid;

      data.push({ meta: time, value: countDecimals(value) > 2 ? value.toFixed(3) : value });
      labels.push(time);
    });

    this.response = sorted;
    this.data = [...data];
    this.labels = [...labels];

    this.update();
  }

  update() {
    const sign = this.settings.valuta === "EUR" ? "€" : "$";
    const decimals = this.settings.unit == 'grammes' ? 3 : 2;
    const length = this.data.length - 1;
    const arrMobile = [Math.floor(length / 100 * 20), Math.floor(length / 100 * 40), Math.floor(length / 100 * 60), Math.floor(length / 100 * 80)]
    const arr = [Math.floor(length / 100 * 10), Math.floor(length / 100 * 20), Math.floor(length / 100 * 30), Math.floor(length / 100 * 40), Math.floor(length / 100 * 50), Math.floor(length / 100 * 60), Math.floor(length / 100 * 70), Math.floor(length / 100 * 80), Math.floor(length / 100 * 90)]
    let lastData = this.data;
    
    // Add last price
    lastData = lastData.pop();

    if( this.element.querySelector('.cd_curprice') ){
      this.element.querySelector('.cd_curprice').textContent     = sign + lastData.value;
      this.element.querySelector('.cd_unit').textContent         = unit[this.settings.unit];
      this.element.querySelector('.cd_type').textContent         = type[this.settings.type];
    }

    const options = {
      showPoint: true,
      showLine: true,
      showArea: false,
      fullWidth: true,
      lineSmooth: false,
      chartPadding: {
        left: 80,
        bottom: 80
      },
      axisX: {
        labelInterpolationFnc: function(value, i) {
          if ( i == length || i == 0) return value;
          return (arrMobile.includes(i)) ? value : null;
        }
      },
      axisY: {
        labelInterpolationFnc: function(value, i) {
          return sign + value.toFixed(decimals);
        }
      }, 
        plugins: [
        ChartistTooltip({
          currency: sign,
          appendToBody: true
        })
      ]
    };

    const responsiveOptions = [['screen and (min-width: 768px)', {
      axisX: {
        labelInterpolationFnc: function(value, i) {
          if (i == length || i == 0) return value;
          return (arr.includes(i)) ? value : null;
        }
      },
    }],]

    const chart = new Chartist.Line(this.entry, { labels: this.labels, series: [this.data] }, options, responsiveOptions);

    chart.on('draw', (ctx) => {
      if (ctx.type === 'label') {
        const dX = ctx.width / 2 + (100 - ctx.width)
        ctx.element.attr({ x: ctx.element.attr('x') - dX - 10 })
      }
    })
  }

  loop() {
    setInterval(() => {
      this.fetchData();
    }, 10000)
  }
}

export default GraphComponent;
